/*eslint-disable */

import {VueEditor} from "vue2-editor";
import axios from 'axios';
import { mapGetters } from 'vuex';
import percentageLoader from "@/components/common/percentage-loader-f-file";
import root from '@/_helpers/roots';
import toast from '@/services/toast';

let modelsForAITaskApiURL = root.modelsForAITaskApiUrl.link;

export default {
  name: 'create-new-models',
  components: {
    VueEditor,
    percentageLoader
  },
  props: [],
  data() {
    return {
      categoryData: [
        'Allogenic Stem Cell Transplant',
        'Aplastic Anemia',
        'Autologous Stem Cell Transplant',
        'Bladder Cancer',
        'Bone Cancer',
        'Breast Cancer',
        'Cancer Drugs',
        'Cervical Cancer',
        'Clinical Oncology',
        'Colon Cancer',
        'Colorectal Cancer',
        'Cytology',
        'Drug Research',
        'Endometrial cancer',
        'Esophageal Cancer',
        'Gastrointestinal Cancer',
        'Glioblastoma',
        'Gynaecological Cancer',
        'Head and Neck Cancer',
        'Immunotherapy',
        'Kidney Cancer',
        'Leukemia',
        'Lung Cancer',
        'Lymphoma',
        'Medical Physics',
        'Melanoma',
        'Multiple Myeloma',
        'Nuclear Medicine',
        'Ovarian Cancer',
        'Pancreatic Cancer',
        'Pathology',
        'Prostrate Cancer',
        'Radiology',
        'Radiotherapy',
        'Retinoblastoma',
        'Sarcoma',
        'Testicular Cancer'
      ],
      algorithmNameOfClassification: [
        'Logistic Regression',
        'Decision Tree Classifier',
        'Random Forest Classifier',
        'Gradient Boosting Classifier',
        'Support Vector Classifier',
        'Gaussian Naive Bias',
        'K-Neighbors Classifier'
      ],
      algorithmNameOfRegression: [
        'Linear Regression',
        'Decision Tree Regressor',
        'Random Forest Regressor',
        'Gradient Boosting Regressor',
        'Support Vector Regressor',
        'K-Neighbors Regressor'
      ],
      createModelFirstStep: true,
      createModelSecondStep: false,
      createModelThirdStep: false,
      createModelFourStep: false,
      createdModelLastStep: false,
      createdModelFinalLastStep: false,
      submitted: false,
      model_name: '',
      category: '',
      algorithm: '',
      usingAlgorithm: '',
      file: null,
      uploadAttachmentName: '',
      description: '',
      createdModelDetails: null,
      recentMostTrainedModelsList: null,
      recentMostTrainedModelsListResults: [],
      chooseUploadFile: '',
      chooseUploadFileList: [],
      homeBackStep: true,
      firstStepBackState: false,
      homeTypeStepBackState: false,
      secondStepBackState: false,
      thirdStepBackState: false,
      modelTrainedLoader: false,
      selectedFileDetails: null,
      is_publish: false,
      diseaseList: {},
      diseaseListResults: [],
      subDiseaseVal: '',
      subDiseaseListResults: [],
      subDiseaseState: false,
      sub2DiseaseVal: '',
      sub2DiseaseListResults: [],
      sub2DiseaseState: false,
      sub3DiseaseVal: '',
      sub3DiseaseListResults: [],
      sub3DiseaseState: false,
      diseaseParentId: '',
      postDiseaseName: '',
      type_model: '',
      modelTypeList: [
        'Classification',
        'Regression'
      ],
      createModelTypeStep: false,
      editorOptions: {
        placeholder: 'Description...',
        editorToolbar: ['bold', 'italic', 'link']
      },
      editorData: '',
      modelPerformanceParsmetersData: null,
      mccState: true,
      sensitivityState: true,
      specificityState: true,
      kappaState: true,
      f1_ScoreState: true,
      r_SquareState: true,
      mAEState: true,
      autoSelectCheckbox: false,
      recommendedModelData: null,
      recommendedModelParameters: [],
      selectedRecomndtParameters: [],
      selectedRcomndtParaIndex: null,
      recommendedModelDflt:[],
      uploadProgress:0
    }
  },
  computed: {
    ...mapGetters([
      'getMostUsedTrainModelForAiDashGetters',
      'getDiseaseForAiDashGetters'
    ]),
    getMostTrainedModlesListFun() {
      this.recentMostTrainedModelsList = this.$store.getters.getMostUsedTrainModelForAiDashGetters.data;
      return
    },
    setInitialStateOfMostTrainedModlesFun() {
      if (this.recentMostTrainedModelsList) {
        this.recentMostTrainedModelsListResults = this.recentMostTrainedModelsList.results
      }
      return
    },
    getDiseasesListFun() {
      this.diseaseList = this.$store.getters.getDiseaseForAiDashGetters.data;
      return
    },
    getDiseasesListIntialStatesFun() {
      if (this.diseaseList) {
        this.diseaseListResults = this.diseaseList.results
      }
      return
    }
  },
  mounted() {
    this.getMostTrainedModlesListFun
    this.setInitialStateOfMostTrainedModlesFun
    this.getDiseasesListFun
    this.getDiseasesListIntialStatesFun
    this.$store.dispatch('getAllAlgoDataForModelTrainedAction').then((res) => {
      this.chooseUploadFileList = res.data.data.results
    })
  },
  methods: {
    patchPerformanceParametersMethod(event) {
      console.log(this.createdModelDetails, "Created Model Info")
      const keyName = event.target.defaultValue
      const value = event.target.checked
      let payload = {
        model_id: this.createdModelDetails.input_data.id,
      }
      if (keyName == 'MCC') {
        if (value) {
          payload.MCC = "True"
          this.mccState = true
        } else {
          payload.MCC = "False"
          this.mccState = false
        }
      } else if (keyName == 'Sensitivity') {
        if (value) {
          payload.Sensitivity = "True"
          this.sensitivityState = true
        } else {
          payload.Sensitivity = "False"
          this.sensitivityState = false
        }
      } else if (keyName == 'Specificity') {
        if (value) {
          payload.Specificity = "True"
          this.specificityState = true
        } else {
          payload.Specificity = "False"
          this.specificityState = false
        }
      } else if (keyName == 'Kappa') {
        if (value) {
          payload.Kappa = "True"
          this.kappaState = true
        } else {
          payload.Kappa = "False"
          this.kappaState = false
        }
      } else if (keyName == 'F1_Score') {
        if (value) {
          payload.F1_Score = "True"
          this.f1_ScoreState = true
        } else {
          payload.F1_Score = "False"
          this.f1_ScoreState = false
        }
      } else if (keyName == 'R_Square') {
        if (value) {
          payload.R_Square = "True"
          this.r_SquareState = true
        } else {
          payload.R_Square = "False"
          this.r_SquareState = false
        }
      } else if (keyName == 'MAE') {
        if (value) {
          payload.MAE = "True"
          this.mAEState = true
        } else {
          payload.MAE = "False"
          this.mAEState = false
        }
      }
      this.$store.dispatch('updateModelInfoByIdAction', payload).then((res) => {
        toast.success('Parameter has been changed');
      })
    },
    backToFirstStepMethod() {
      this.homeBackStep = true
      this.firstStepBackState = false
      this.createModelTypeStep = false
      setTimeout(() => {
        this.createModelFirstStep = true
      }, 1)
    },
    backToHomeTypeStepMethod() {
      this.firstStepBackState = true
      this.homeTypeStepBackState = false
      this.createModelSecondStep = false
      setTimeout(() => {
        this.createModelTypeStep = true
      }, 1)
    },
    backToSecondStepMethod() {
      this.homeTypeStepBackState = true
      this.thirdStepBackState = false
      this.createModelThirdStep = false
      setTimeout(() => {
        this.createModelSecondStep = true
      }, 1)
    },
    backToThirdStepMethod() {
      this.secondStepBackState = true
      this.thirdStepBackState = false
      this.createModelFourStep = false
      setTimeout(() => {
        this.createModelThirdStep = true
      }, 1)
    },
    selectedchooseUploadFileFun(fileD, val) {
      this.chooseUploadFile = val
      this.selectedFileDetails = fileD
    },
    clearSelectedFileForModelTrainerMethod() {
      this.chooseUploadFile = ''
      this.selectedFileDetails = ''
      this.$validator.reset()
    },
    clearUploadedFileForModelTrainerMethod() {
      this.file = null
      this.uploadAttachmentName = ''
      this.$validator.reset();
    },
    handleAttachmentUpload(event) {
      if (event.target.files && event.target.files.length > 0) {
        this.file = event.target.files[0];
        this.files = this.$refs.file.files[0];
        this.uploadAttachmentName = this.files.name
      } else {
        this.uploadAttachmentName = '';
      }
    },
    selectedAlgorithmFun(val) {
      this.algorithm = val
      this.usingAlgorithm = val
    },
    modelTypeSelectFun(mType) {
      this.type_model = mType
      if (mType == 'Regression') {
        this.algorithm = ''
        this.usingAlgorithm = ''
      } else {
        this.algorithm = ''
        this.usingAlgorithm = ''
      }
    },
    selectedCategoryFun(DiseaseVal) {
      if (DiseaseVal == 'Other') {
        this.subDiseaseState = false
        this.subDiseaseState = false
        this.category = DiseaseVal
        this.postDiseaseName = DiseaseVal
      } else {
        this.category = DiseaseVal.name
        this.postDiseaseName = DiseaseVal.name
        if (DiseaseVal.sub_disease.length > 0) {
          this.subDiseaseListResults = DiseaseVal.sub_disease
          this.subDiseaseState = true
        } else {
          this.subDiseaseListResults = []
          this.subDiseaseState = false
        }
      }
    },
    selectedSubCategoryFun(DiseaseVal) {
      this.postDiseaseName = ''
      this.diseaseParentId = ''
      this.subDiseaseVal = DiseaseVal.name
      this.postDiseaseName = DiseaseVal.name
      this.diseaseParentId = DiseaseVal.parent
      if (DiseaseVal.sub_disease.length > 0) {
        this.sub1DiseaseListResults = DiseaseVal.sub_disease
        this.sub2DiseaseState = true
      } else {
        this.sub1DiseaseListResults = []
        this.sub2DiseaseState = false
      }
    },
    selectedSub2CategoryFun(DiseaseVal) {
      this.postDiseaseName = ''
      this.diseaseParentId = ''
      this.sub2DiseaseVal = DiseaseVal.name
      this.postDiseaseName = DiseaseVal.name
      this.diseaseParentId = DiseaseVal.parent
      if (DiseaseVal.sub_disease.length > 0) {
        this.sub2DiseaseListResults = DiseaseVal.sub_disease
        this.sub3DiseaseState = true
      } else {
        this.sub2DiseaseListResults = []
        this.sub3DiseaseState = false
      }
    },
    selectedSub3CategoryFun(DiseaseVal) {
      this.postDiseaseName = ''
      this.diseaseParentId = ''
      this.sub3DiseaseVal = DiseaseVal.name
      this.postDiseaseName = DiseaseVal.name
      this.diseaseParentId = DiseaseVal.parent
      if (DiseaseVal.sub_disease.length > 0) {
        this.sub3DiseaseListResults = DiseaseVal.sub_disease
      } else {
        this.sub3DiseaseListResults = []
        this.sub3DiseaseState = false
      }
    },
    stepFirstFormMethod() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.submitted = true
          this.createModelFirstStep = false
          setTimeout(() => {
            this.createModelTypeStep = true
          }, 1)
          this.homeBackStep = false
          this.firstStepBackState = true
          this.submitted = false
          return;
        }
      })
    },
    stepModelTypeFormMethod() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.submitted = true
          this.createModelTypeStep = false
          setTimeout(() => {
            this.createModelSecondStep = true
          }, 1)
          this.firstStepBackState = false
          this.homeTypeStepBackState = true
          this.submitted = false
          return;
        }
      })
    },
    stepSecondFormMethod() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.submitted = true
          this.createModelSecondStep = false
          setTimeout(() => {
            this.createModelThirdStep = true
          }, 1)
          this.homeTypeStepBackState = false
          this.secondStepBackState = true
          this.submitted = false
          return;
        }
      })
    },
    stepThirdFormMethod() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.submitted = true
          this.$store.dispatch('getAllAlgoDataForModelTrainedAction').then((res) => {
            this.chooseUploadFileList = res.data.data.results
            this.createModelThirdStep = false
            setTimeout(() => {
              this.createModelFourStep = true
            }, 1)
            this.secondStepBackState = false
            this.thirdStepBackState = true
            this.submitted = false
          }).catch((err) => {
            this.submitted = false
          })
          return;
        }
      })
    },
    stepFourFormMethod() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.submitted = true
          this.modelTrainedLoader = true
          var formData = new FormData();
          formData.append('name', this.model_name);
          formData.append('disease', this.postDiseaseName);
          formData.append('algorithm', this.usingAlgorithm);
          formData.append('display_name_algorithm', this.algorithm);
          formData.append('parent', this.diseaseParentId);
          formData.append('subDisease', this.subDiseaseVal);
          formData.append('type_model', this.type_model);
          if (this.autoSelectCheckbox) {
            formData.append('auto_select', true);
          }
          if (this.selectedFileDetails) {
            formData.append('data_url', this.selectedFileDetails.data_file);
            formData.append('data_url_name', this.selectedFileDetails.data_file_name);
            formData.append('data', this.selectedFileDetails.id);
          } else {
            formData.append('data_file', this.file);
            formData.append('data_file_name', this.uploadAttachmentName);
            // Select Data Storage In Bucket
            var formData1 = new FormData();
            formData1.append('category', this.postDiseaseName);
            formData1.append('data_file', this.file);
            formData1.append('data_file_name', this.uploadAttachmentName);
            formData1.append('is_public', this.is_publish);
            this.$store.dispatch('createAlgoDataDetailsAction', formData1)
            // Select Data Storage In Bucket
          }
          axios.post(modelsForAITaskApiURL, formData, {
            onUploadProgress: progressEvent => {
              this.uploadProgress = Math.round(
                (progressEvent.loaded / progressEvent.total) * 100
              );
            },
          }).then((response) => {
              if (this.autoSelectCheckbox) {
                this.$store.dispatch('getRecommendedParametersAction').then((res) => {
                  this.createdModelLastStep = true
                  this.recommendedModelData = res.data.data.input_data
                  this.recommendedModelParameters = this.recommendedModelData.parameters_list
                  toast.success(response.data.msg);
                  this.createdModelDetails = response.data.data
                  this.createModelTypeStep = false
                  this.createModelFourStep = false
                  this.thirdStepBackState = false
                  this.homeBackStep = true
                  this.modelTrainedLoader = false
                  this.submitted = false
                })
              } else {
                this.$store.dispatch('getModelPerformanceParameterListAction').then((res) => {
                  this.modelPerformanceParsmetersData = res.data.data
                  this.createdModelFinalLastStep = true
                  toast.success(response.data.msg);
                  this.createdModelDetails = response.data.data
                  this.createModelTypeStep = false
                  this.createModelFourStep = false
                  this.thirdStepBackState = false
                  this.homeBackStep = true
                  this.modelTrainedLoader = false
                  this.submitted = false
                })
              }
            }).catch((err) => {
              this.submitted = false
              this.modelTrainedLoader = false
              toast.error(err.data.user_msg || err.data.msg);
            })
          return;
        }
      })
    },
    selectRecomdtAlgoMethod(data, index) {
      this.selectedRecomndtParameters.push(data)
      this.selectedRcomndtParaIndex = index
    },
    recommendedModelSavedMethod() {
      var payload;
      if(this.selectedRecomndtParameters.length > 0){
         payload = {
          id: this.recommendedModelData.id,
          type: this.recommendedModelData.type,
          parameters_list: this.selectedRecomndtParameters
        }
      }else{
        payload = {
          id: this.recommendedModelData.id,
          type: this.recommendedModelData.type,
          parameters_list:[]
        }
      }
      this.submitted = true
      this.$store.dispatch('saveRecommenededParametersAction', payload).then((res) => {
        this.createdModelDetails = res.data.data
        this.$store.dispatch('getModelPerformanceParameterListAction').then((response) => {
          this.modelPerformanceParsmetersData = response.data.data
          this.submitted = false
          this.createdModelLastStep = false
          this.createdModelFinalLastStep = true
        })
      }).catch((err) => {
        this.submitted = false
      })
    },
    updateCreatedModelsFormMethod() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.submitted = true
          var formData = new FormData();
          formData.append('name', this.model_name);
          formData.append('description', this.description);
          this.$store.dispatch('updateModelDetailsByIDForAIFun', {
              data: {
                data: formData,
                id: this.createdModelDetails.input_data.id
              }
            })
            .then((res) => {
              toast.success(res.data.msg);
              this.$router.push({
                name: 'AiDashboard'
              })
              this.submitted = false
            }).catch((err) => {
              this.submitted = false
              toast.error(err.data.user_msg || err.data.msg);
            })
          return;
        }
      })
    }
  },
  watch: {
    getMostTrainedModlesListFun() {
      return this.$store.getters.getMostUsedTrainModelForAiDashGetters;
    },
    setInitialStateOfMostTrainedModlesFun() {
      if (this.recentMostTrainedModelsList) {
        this.recentMostTrainedModelsListResults = this.recentMostTrainedModelsList.results
      }
      return
    },
    getDiseasesListFun() {
      return this.$store.getters.getDiseaseForAiDashGetters
    },
    getDiseasesListIntialStatesFun() {
      if (this.diseaseList) {
        this.diseaseListResults = this.diseaseList.results
      }
      return
    }
  }
}